var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { resolveStrokeWidth, strokeContextForCanvas, getActiveDiagram } from '../theme';
import { createDiagramGroup, readCanvasSize, } from '../helpers';
import { createPipelineStage, } from '../primitives';
import { pipelineLayout } from '../layouts';
import { connectNodes } from '../connectors';
import { createPipelineSymbol } from '../pipelineSymbols';
import { listPipelineSymbols } from '../pipelineIcons';
import { maybeApplyDiagramFlow } from '../flow';
/** Create horizontal process pipeline */
export function createPipeline(app, stages, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) { options = {}; }
    var group = createDiagramGroup(app, 'processPipeline', __assign(__assign({}, options), { stages: stages }), { name: 'pipeline' });
    var canvas = readCanvasSize(options);
    var strokeCtx = strokeContextForCanvas(canvas.width, canvas.height);
    var edgeWidth = resolveStrokeWidth(getActiveDiagram().stroke.edge, strokeCtx);
    var stageNodes = [];
    try {
        for (var stages_1 = __values(stages), stages_1_1 = stages_1.next(); !stages_1_1.done; stages_1_1 = stages_1.next()) {
            var stage = stages_1_1.value;
            var node = createPipelineStage(app, stage.label, (_b = stage.status) !== null && _b !== void 0 ? _b : 'pending', stage.type);
            node.metadata = __assign(__assign(__assign({}, node.metadata), { diagramId: stage.id, pipelineStatus: stage.status }), (stage.type ? { pipelineSymbolKind: stage.type } : {}));
            group.add(node);
            stageNodes.push(node);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (stages_1_1 && !stages_1_1.done && (_a = stages_1.return)) _a.call(stages_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    pipelineLayout(group, Math.max(8, Math.floor((canvas.width - 48) / Math.max(stages.length, 1) / 3)), 12, canvas.height);
    for (var i = 0; i < stages.length; i++) {
        var stage = stages[i];
        var node = stageNodes[i];
        if (typeof stage.x === 'number')
            node.x = stage.x;
        if (typeof stage.y === 'number')
            node.y = stage.y;
        if (typeof stage.rotation === 'number')
            node.rotation = stage.rotation;
    }
    var edgeLayer = app.group({ zIndex: -10, listening: false });
    edgeLayer.metadata.diagramEdgeLayer = true;
    for (var i = 0; i < stageNodes.length - 1; i++) {
        edgeLayer.add(connectNodes(app, stageNodes[i], stageNodes[i + 1], [], {
            parent: group,
            style: 'straight',
            stroke: getActiveDiagram().edge,
            glowColor: getActiveDiagram().edgeGlow,
            strokeWidth: edgeWidth,
            arrowEnd: 'filled',
        }));
    }
    group.add(edgeLayer);
    maybeApplyDiagramFlow(app, group, options);
    return group;
}
/** Grid catalog of pipeline / process / manufacturing symbols. */
export function createPipelineSymbolCatalog(app, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var category = options.category;
    var kinds = listPipelineSymbols(category);
    var columns = Math.max(4, (_a = options.columns) !== null && _a !== void 0 ? _a : 8);
    var group = createDiagramGroup(app, 'pipelineSymbolCatalog', __assign(__assign({}, options), { category: category }), { name: 'pipelineCatalog' });
    var gapX = 120;
    var gapY = 102;
    var startX = 16;
    var startY = 12;
    kinds.forEach(function (meta, i) {
        var col = i % columns;
        var row = Math.floor(i / columns);
        var node = createPipelineSymbol(app, meta.kind, startX + col * gapX, startY + row * gapY, meta.label);
        node.metadata = __assign(__assign({}, node.metadata), { diagramId: meta.kind });
        group.add(node);
    });
    return group;
}
